export const ALERTS_IDS = Object.freeze({
  wbapp: 'wbapp',
  grItemNode: 'grItemNode',
  hdNode: 'hdNode',
  hdModal: 'hdModal',
  hdTreeExport: 'hdTreeExport',
  hdTreeImport: 'hdTreeImport',
  irdCsv: 'irdCsv',
  irdModal: 'irdModal',
  sbMenuLinkEditor: 'sbMenuLinkEditor',
  sbImageEditor: 'sbImageEditor',
  sbQREditor: 'sbQREditor',
  sbServiceLinkEditor: 'sbServiceLinkEditor',
});

export const CONFIRMS_IDS = Object.freeze({
  hbSlideEditor: 'hbSlideEditor',
  guestRequestNodeCategory: 'guestRequestNodeCategory',
  irdCategoryEditor: 'irdCategoryEditor',
  irdNodeItem: 'irdNodeItem',
  sbImageEditor: 'sbImageEditor',
  sbQREditor: 'sbQREditor',
  sbMenuLinkEditor: 'sbMenuLinkEditor',
  sbServiceLinkEditor: 'sbServiceLinkEditor',
  wbapp: 'wbapp',
});
